// src/admin/views/GolferAdminView.js
import React from 'react'
import '../../styles/admin.css'
import ConfirmationModal from '../components/ConfirmationModal'
import PageHeader from '../components/PageHeader'
import ToggleSwitch from '../components/ToggleSwitch'

function GolferAdminView({
  golferData,
  orgName,
  handleChange,
  handleSubmit,
  handleDelete,
  handleCancel,
}) {
  const [showConfirmation, setShowConfirmation] = React.useState(false)

  return (
    <>
      <PageHeader pageName={'Golfer Info'} backTo="/admin/golfers" />
      <div className="admin-card-container">
        <div className="admin-card">
          <form onSubmit={handleSubmit}>
            <div className="admin-input-group">
              <label className="admin-label">Organization</label>
              <input
                type="text"
                className="admin-input"
                value={orgName || ''}
                readOnly
                disabled
                style={{ backgroundColor: '#f7fafc', color: '#4a5568' }}
              />
            </div>

            <div className="admin-input-group">
              <label htmlFor="golferName" className="admin-label">
                Golfer Name
              </label>
              <input
                type="text"
                id="golferName"
                name="golferName"
                className="admin-input"
                value={golferData?.golferName}
                onChange={handleChange}
                required
                placeholder="e.g. Scottie Scheffler"
              />
            </div>

            <div className="admin-input-group">
              <label htmlFor="email" className="admin-label">
                Golfer Email
              </label>
              <input
                type="text"
                id="email"
                name="email"
                className="admin-input"
                value={golferData?.email}
                onChange={handleChange}
                required
                placeholder="name@example.com"
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
              <ToggleSwitch
                label="Competitor"
                name="competitor"
                checked={golferData?.competitor}
                onChange={handleChange}
              />
              <ToggleSwitch label="Inactive" name="inactive" checked={golferData?.inactive} onChange={handleChange} />
            </div>

            <div className="admin-button-group">
              {golferData?.golferId && (
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setShowConfirmation(true)}
                  style={{ marginRight: 'auto' }}
                >
                  Delete
                </button>
              )}

              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save Changes
              </button>
            </div>
          </form>
        </div>

        <ConfirmationModal
          questionText="Are you sure you want to delete this golfer? Doing so will delete all associated round data. Type DELETE to confirm."
          showConfirmation={showConfirmation}
          setShowConfirmation={setShowConfirmation}
          onConfirm={handleDelete}
        />
      </div>
    </>
  )
}

export default GolferAdminView
